const documentTemplate = {
  id: null,
  name: null,
  documentTypeId: null,
  documentTypeName: null,
  clientId: null,
  clientName: null,
  htmlBody: null,
  isActive: true,
  createdBy: null,
  updatedBy: null,
  createdAt: null,
  updatedAt: null,
  deactivatedByUserId: null,
  deactivatedAt: null
}

export default () => Object.assign({}, documentTemplate)
